import {
  JsonRTEBlockItem,
} from '@design-system/json-rte';
import { MAX_VISIBLE_ITEMS } from '~/constants/rteConstants';

export const getLimitedRTE = (
  rte: JsonRTEBlockItem,
  limit = MAX_VISIBLE_ITEMS,
  expanded = false
) => {
  if (!rte?.children) {
    return {
      content: rte,
      hasMore: false,
    };
  }

  let hasReachedLimit = false;
  let hasMore = false;

  const filteredChildren: JsonRTEBlockItem['children'] = [];

  rte.children.forEach((child) => {
    if (hasReachedLimit && !expanded) {
      return;
    }

    if (
      'type' in child &&
      child.type === 'ol' &&
      Array.isArray(child.children)
    ) {
      if (child.children.length > limit) {
        hasMore = true;
      }

      const limitedItems = expanded
        ? child.children
        : child.children.slice(0, limit);

      filteredChildren.push({
        ...child,
        children: limitedItems,
      });

      if (!expanded && child.children.length > limit) {
        hasReachedLimit = true;
      }

      return;
    }

    filteredChildren.push(child);
  });

  return {
    content: {
      ...rte,
      children: filteredChildren,
    },
    hasMore,
  };
};